// src/components/intake/DetailRows.jsx
//
// Label/value rows, as the mock-up's review table. A value may be a node, so a
// file name can be a download link.

import React from 'react';
import { Box } from '@mui/material';
import { SP } from './intakeSx';

export default function DetailRows({ rows, testId }) {
  return (
    <Box sx={{ mt: 2.5, borderTop: `1px solid ${SP.lineSoft}` }} data-testid={testId}>
      {rows.map(({ label, value }) => (
        <Box
          key={label}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            py: '11px',
            borderBottom: `1px solid ${SP.lineSoft}`,
            fontSize: 13,
          }}
        >
          <Box component="span" sx={{ color: SP.gray, flexShrink: 0 }}>
            {label}
          </Box>
          <Box component="span" sx={{ fontWeight: 600, textAlign: 'right', minWidth: 0, overflowWrap: 'anywhere' }}>
            {value}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
